/**
  Utility functions such as date format, time since, etc
*/

export default class ZUtil {

  
  currency(x) {
    if(x && x != null  && x != 'null' && x != 'undefined'){
      // alert(x);
      // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parseFloat(x).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }else{
      return '0.00';
    }
  }

  timeSince (date) {
  if (typeof date !== 'object') {
    date = new Date(date);
  }

  var seconds = Math.floor((new Date() - date) / 1000);
  var intervalType;

  var interval = Math.floor(seconds / 31536000);
  if (interval >= 1) {
    intervalType = 'tahun';
  } else {
    interval = Math.floor(seconds / 2592000);
    if (interval >= 1) {
      intervalType = 'bulan';
    } else {
      interval = Math.floor(seconds / 86400);
      if (interval >= 1) {
        intervalType = 'hari';
      } else {
        interval = Math.floor(seconds / 3600);
        if (interval >= 1) {
          intervalType = "jam";
        } else {
          interval = Math.floor(seconds / 60);
          if (interval >= 1) {
            intervalType = "minit";
          } else {
            interval = seconds;
            intervalType = "saat";
          }
        }
      }
    }
  }

  if (interval > 1 || interval === 0) {
    intervalType += '';
  }

  return interval + ' ' + intervalType;
};

  dateformat(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    if(date) {
      var dd = String(date.getUTCDate()).padStart(2, '0');
      var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date.getUTCFullYear();

      return dd + '/' + mm + '/' + yyyy;
    }
    else {
      return '-'
    }
  };

  dateformformat(date) {
    if (typeof date !== 'object') {
      date = new Date(date);
    }

    // return date.toJSON().slice(0, 10).replace(/-/g, '-');

    var dd = String(date.getUTCDate()).padStart(2, '0');
    var mm = String(date.getUTCMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getUTCFullYear();

    return yyyy + '-' + mm + '-' + dd;

    let m = date.getMonth()
    m = m < 10 ? '0' + m : m;
    let d = date.getDay()
    d = d < 10 ? '0' + d : d;

    return date.getFullYear() + '-' + m + '-' + d ;
  };

  can(permissionName) {
    return this.app.$page.props.auth.user.permissions.indexOf(permissionName) !== -1;
  };

  role(roleName) {
    return this.app.$page.props.auth.user.roles.indexOf(roleName) !== -1;
  };

  pasti(msg = 'Adakah anda pasti?', title = 'Memohon Kepastian') {

    const swalWithBootstrapButtons = this.app.$swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success ml-2',
        cancelButton: 'btn btn-danger ml-2'
      },
      buttonsStyling: false
    })

    return new Promise((resolve, reject) => {
        swalWithBootstrapButtons.fire({
        title: title,
        text: msg,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Batal',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          resolve(result.value)
          // swalWithBootstrapButtons.fire(
          //   'Deleted!',
          //   'Your file has been deleted.',
          //   'success'
          // )
        } else if (
          /* Read more about handling dismissals below */
          result.dismiss === 'cancel'
        ) {
          resolve(false)
          // swalWithBootstrapButtons.fire(
          //   'Cancelled',
          //   'Your imaginary file is safe :)',
          //   'error'
          // )
        }
      })
      .catch(err => {
        reject(err)
      })
    }); // promise
  }


  timeConvert (date) {
      return (new Date(date)).toLocaleTimeString('en-MY', { hour12: false })
  }

  zeroPad (num, places) { return String(num).padStart(places, '0')}

  globalRoute(named, param) {
    if (route().check(named)) {
      return route(named, param)
    }

    return this.app.globalRoute().check(named) ? this.app.globalRoute(named, param) + '?logged=' + this.app.$page.auth.user.token : '/'
  }

  notify(msg, success = true) {
    if(success)
      this.app.$page.props.flash.notify = msg
    else
      this.app.$page.props.flash.notifyerror = msg
  }

    message(msg, success = true) {
    if(success) {
      this.app.$page.props.flash.success = ''
      this.app.$page.props.flash.success = msg
    }
    else {
      this.app.$page.props.flash.error = ''
      this.app.$page.props.flash.error = msg
    }
  }

}
